import { EmailVerificationState, EmailVerificationStepName } from 'User/types/emailVerification';


const initialState: EmailVerificationState = {
  steps: [
    {
      stepName: EmailVerificationStepName.LANDING,
    },
  ],
  flowDisabled: false,
};

export default initialState;
